import React from 'react';
import { useReferencedComponent } from '@hooks/useReferencedComponent';
import { useAuth0Token } from '@hooks/useAuth0Token';
import { Competition } from '@components/Competition/Competition';
import { CompetitionSerializerProps, SanityCompetitionData } from './Competition.types';

export const CompetitionBlock = ({ documentId }: { documentId: string }) => {
  const { loading } = useAuth0Token();
  const data = useReferencedComponent(documentId) as SanityCompetitionData | null;

  if (loading || !data || data.ended) return null;

  return (
    <Competition
      competitionId={documentId}
      title={data.title}
      ingress={data.ingress}
      questions={data.questions || []}
      endDate={data.endDate}
      image={data.image}
      video={data.video}
      style={data.style || 'white'}
      answerStatus={data.answerStatus}
      requireTermsApproval={data.requireTermsApproval ?? false}
      termsLinkSlug={data.termsLink?.slug ?? ''}
      userAccessibility={data.userAccessibility}
    />
  );
};

export const CompetitionReferenceBlock = ({ value }: CompetitionSerializerProps) => (
  <CompetitionBlock documentId={value._ref} />
);
